import { ref } from 'vue';

type ToastStatus = 'success' | 'error' | 'warning' | 'info';

type ToastOptions = {
  status: ToastStatus;
  message: string;
  closeable?: boolean;
  autoClose?: boolean;
  autoCloseAfter?: number;
  actionLabel?: string;
  actionHref?: string;
  buttonTitle?: string;
  hideIcon?: boolean;
  useAnimation?: boolean;
  iconTitle?: string;
  closeIconTitle?: string;
  onAction?: () => void;
  onDismiss?: () => void;
  onAfterClose?: () => void;
};

type Toast = ToastOptions & {
  id: number;
};

const toasts = ref<Toast[]>([]);
let toastIdCounter = 0;

const addToast = (options: ToastOptions): number => {
  const id = ++toastIdCounter;
  toasts.value.push({
    id,
    ...options,
  });
  return id;
};

const removeToast = (id: number) => {
  toasts.value = toasts.value.filter((t) => t.id !== id);
};

export { removeToast, toasts };

const DEFAULT_TOAST_OPTIONS = {
  closeable: true,
  autoClose: true,
  autoCloseAfter: 4000,
  useAnimation: true,
};

export const useSdfToast = () => {
  const createToast = (status: ToastStatus) => {
    return (message: string, options?: Partial<Omit<ToastOptions, 'status' | 'message'>>) => {
      return addToast({
        ...DEFAULT_TOAST_OPTIONS,
        status,
        message,
        ...options,
      });
    };
  };

  const clear = () => {
    toasts.value = [];
  };

  return {
    success: createToast('success'),
    error: createToast('error'),
    warning: createToast('warning'),
    info: createToast('info'),
    clear,
  };
};
